<div [ngSwitch]="useVersionNo">
  <ng-container *ngSwitchCase="'1'">
    <app-not-found></app-not-found>
  </ng-container>
  <ng-container *ngSwitchCase="'2'">
    <app-not-found2></app-not-found2>
  </ng-container>
   <ng-container *ngSwitchDefault></ng-container>
</div>